import { Box } from '@mui/material';
import React from 'react';
import Logo from '../../Assets/img/logo.svg';
import Bg from '../../Assets/img/irregularBg.svg';
import './Loader.css';

export default function Loader() {
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100vh',
			}}
		>
			<Box
				className='bg-logo'
				sx={{
					backgroundImage: `url(${Bg})`,
					backgroundPosition: 'center',
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					width: '250px',
					height: '250px',
					borderRadius: '50%',
					// backgroundColor: '#c9c9c9',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			/>

			<Box sx={{ position: 'absolute' }}>
				<img src={Logo} alt='' className='scale-down-center' width='300px' />
			</Box>
		</Box>
	);
}
